__turbopack_context__.v({
  "back": "ZdXaHa_back",
  "card": "ZdXaHa_card",
  "eyebrow": "ZdXaHa_eyebrow",
  "grid": "ZdXaHa_grid",
  "image": "ZdXaHa_image",
  "imageWrap": "ZdXaHa_imageWrap",
  "intro": "ZdXaHa_intro",
  "label": "ZdXaHa_label",
  "panel": "ZdXaHa_panel",
  "placeholder": "ZdXaHa_placeholder",
  "subtitle": "ZdXaHa_subtitle",
  "toolbar": "ZdXaHa_toolbar",
});
